import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  newPassword: string = '';
  confirmPassword: string = '';
  user: any;
  imageUrl: any;
  errors: string[] = [];
  newFile: any;
  uploadProgress: Observable<any>;
  imageID: string;
  imageUploading: boolean = false;
  isUpdated: boolean = false;
  isPasswordUpdated: boolean = false;

  constructor(
    public auth: AuthService,
    private afStorage: AngularFireStorage
  ) {}

  async ngOnInit() {
    this.user = Object.assign({}, this.auth.user)
    this.user.email = this.auth.decrypt(this.user.email)
    this.imageUrl = this.user.photoURL ? this.user.photoURL : '/assets/avatar.png'

    this.isUpdated = false
    this.isPasswordUpdated = false
  }

  openFileBrowser(event: any) {
      event.preventDefault();

      let element: HTMLElement = document.getElementById('avatarPhoto') as HTMLElement;
      element.click();
  }

  onFileChange(event: any) {
    let files = event.target.files;

    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageUrl = e.target.result;
    }
    reader.readAsDataURL(files[0]);
    this.newFile = files[0];
  }

  async updateUserProfileData(email) {
    this.isUpdated = false;
    if (this.newFile) {
      await this.uploadPhoto(this.newFile)
      this.imageUploading = false;
      let downloadURL = this.afStorage.ref("/photos/" + this.imageID).getDownloadURL()
      downloadURL.subscribe(url=>{
        if(url) {
          this.auth.updateUserData({
            uid: this.auth.user.uid,
            email: email,
            displayName: this.user.displayName,
            photoURL: url,
            source: this.user.source,
            role: this.auth.user.role
          })
          .then(() => {
            this.isUpdated = true
            this.getUpdatedUser();

            let self = this
            setTimeout(function() {
              self.isUpdated = false
            }, 3000);
          })
        }
      })
    } else {
      this.auth.updateUserData({
        uid: this.auth.user.uid,
        email: email,
        displayName: this.user.displayName,
        photoURL: this.auth.user.photoURL,
        source: this.user.source,
        role: this.auth.user.role
      })
      .then(() => {
        this.isUpdated = true
        let self = this
        setTimeout(function() {
          self.isUpdated = false
        }, 3000);
        this.getUpdatedUser();
      })
    }
  }

  async updateUserData() {
    if (this.imageUploading) return;

    this.errors = [];
    if (this.user.displayName.length < 4) this.errors.push('invalid-name');
    if (this.validEmail() === false) this.errors.push('invalid-email');

    if (this.errors.length > 0) return false;

    if (this.user.email !== this.auth.decrypt(this.auth.user.email)) {
      let self = this;
      this.auth.updateEmail(this.user.email).then(() => {
        self.updateUserProfileData(this.auth.encrypt(this.user.email))
      }).catch(error => {
        console.log(error);
        self.errors = [];
        if (error.code === "auth/requires-recent-login") {
          self.errors.push(error.code)
        } else {
          self.errors.push('update-email-fail');
        }
      })
    } else {
      this.updateUserProfileData(this.auth.user.email)
    }
  }

  async getUpdatedUser() {
    let obj = await this.auth.getUser();
    this.auth.setUser(obj)
  }

  validEmail(): boolean {
    if (this.user.email === '') return false;

    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(this.user.email);
  }

  validPassword(): boolean {
    if (this.user.password === '') return false;

    let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    return regex.test(this.newPassword);
  }

  canUpdateUser(): boolean {
    return this.user.displayName !== '' && this.user.email !== '';
  }

  canResetPassword(): boolean {
    return this.newPassword !== '' && this.confirmPassword !== '';
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }

  uploadPhoto(file) {
    this.imageID = Math.random().toString(36).substring(2);
    this.imageUploading = true;
    let ref = this.afStorage.ref("/photos/" + this.imageID);
    let task = ref.put(file);
    this.uploadProgress = task.snapshotChanges()
      .pipe(map(s => (s.bytesTransferred / s.totalBytes) * 100));

    return task
  }

  resetPassword() {
    this.errors = [];
    if (this.validPassword() === false) this.errors.push('invalid-password');

    if (this.newPassword !== this.confirmPassword) this.errors.push('password-mismatch');

    if (this.errors.length > 0) return false;

    this.isPasswordUpdated = false;
    let self = this
    this.auth.updatePassword(this.newPassword).then(() => {
      self.isPasswordUpdated = true
      setTimeout(function() {
        self.isPasswordUpdated = false
      }, 3000);
    }).catch(function(error) {
      console.log(error);
      self.errors = [];
      if (error.code === "auth/requires-recent-login") {
        self.errors.push(error.code)
      } else {
        self.errors.push('password-reset-fail');
      }
    });
  }
}
